<template>
  <div>
    <!-- <v-card>
      <div class="text-xs-right">
        <v-btn fab small flat @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text> -->
    <v-layout wrap>
      <v-flex xs12 sm8>
        <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
          <filter-category
            :categories="categories"
            v-model="currentCategorys"
            :stat="filterBadge"
          ></filter-category>
        </div>
      </v-flex>
      <v-flex xs12 sm4>
        <div class="form-control">
          <input
            type="text"
            name="search"
            id="search"
            v-model="searchInput"
            :placeholder="$t('Search')"
            @input="$emit('update:search', searchInput)"
          />
        </div>
      </v-flex>
    </v-layout>
    <template v-if="loadingProduct">
      <div class="spinner text-xs-center mb-5 mt-5">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </template>
    <template v-else>
      <template v-if="filterProducts.length == 0">
        <v-alert :value="true" color="grey" icon="info" outline>{{
          $t('No product found')
        }}</v-alert>
      </template>
      <template v-else>
        <div class="mt-2 mb-2 text-xs-center">
          <v-pagination
            :length="pageCount"
            v-model="pageNumberData"
            @input="onClickPagination"
          ></v-pagination>
        </div>
        <v-layout wrap>
          <v-flex
            xs6
            sm3
            lg2
            v-for="product in filterProducts"
            :key="'product_' + product.id"
            class="pa-2"
          >
            <v-card style="height: 100%">
              <template v-if="product.photourl && product.photourl.split(';;').length > 0">
                <v-img :src="product.photourl.split(';;')[0]" aspect-ratio="1" alt></v-img>
              </template>
              <v-card-text class="card-text">
                <div class="text-overflow">
                  {{ product.name | truncate(40) }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="mt-auto"
                  small
                  depressed
                  color="primary"
                  @click="onSelectProduct(product)"
                  style="width: 100%"
                  >{{ $t('Select') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <div class="mt-2 mb-2 text-xs-center">
          <v-pagination
            :length="pageCount"
            v-model="pageNumberData"
            @input="onClickPagination"
          ></v-pagination>
        </div>
      </template>
    </template>
    <!-- </v-card-text>
    </v-card> -->
  </div>
</template>

<script>
import FilterCategory from '@/components/view/template/ecommerce/FilterCategory'
export default {
  props: {
    value: {
      default: false
    },
    filterProducts: {
      default: null
    },
    search: {
      default: null
    },
    categories: {
      default: null
    },
    currentCategory: {
      default: null
    },
    filterBadge: {
      default: null
    },
    pageCount: { default: 0 },
    pageNumber: { default: 0 },
    loadingProduct: { default: false }
  },
  components: { FilterCategory },
  data: function() {
    return {
      pageNumberData: this.pageNumber,
      searchInput: this.search,
      currentCategorys: this.currentCategory
    }
  },
  watch: {
    currentCategorys: function(newVal, oldVal) {
      if (newVal != oldVal) {
        const vm = this
        vm.$emit('update:currentCategory', newVal)
      }
    }
  },
  methods: {
    closeDialog() {
      const vm = this
      vm.$emit('closeDialog')
    },
    onSelectProduct(product) {
      const vm = this
      vm.$emit('onSelectProduct', product)
    },
    onClickPagination() {
      const vm = this
      vm.$emit('onClickPagination', vm.pageNumberData)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-text {
  min-height: 80px;
  .text-overflow {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/GenericProduct.vue